(function ($) {
	$(window).on("resize", function() {
		//"square-ize" all square images
		$(".product-image.square, .product-image-hover.square").each(function() {
			$(this).height(1 * $(this).outerWidth());
		});
	}).trigger('resize');
	// add label to quantity input
	$('.quantity:has(input.qty)').each(function() {
		if (!$(this).is('.hidden')) {
			$('<label>Quantity</label>').insertBefore($(this));
		}
	});
	// see parts/shop-header-bar.php for this variable's definition
	if (typeof itemsInCart != 'undefined' && itemsInCart > 0) {
		$(".cart-menu-icon").prepend('<div class="cart-menu-icon-count">'+itemsInCart+'</div>');
	}

	// on single product page, adjust product description's top margin 
	// depending on message div's height, if any
	var $summaryDiv = $('.single-product .summary.entry-summary');
	var $messageDiv = $('.single-product .woocommerce-notices-wrapper');
	$summaryDiv.css('margin-top', $messageDiv.outerHeight()+'px');

	// highlight Shop menu on woocommerce pages
	if (typeof isOnWoocommercePage != 'undefined' && isOnWoocommercePage) {
		$('.menu-item a[href="/shop"]').parents('.menu-item').addClass('current');
	}

	// select styles
  $('.single-product .summary.entry-summary select, .checkout select, .woocommerce-ordering select, .gform_body select').each(function(){
    var $this = $(this), numberOfOptions = $(this).children('option').length;

    $this.addClass('select-hidden');
		$this.wrap('<div class="select"></div>');
    $this.after('<div class="select-styled"></div>');

    var $styledSelect = $this.next('div.select-styled');
    $styledSelect.text($this.children('option').eq(0).text());

    var $list = $('<ul />', {
        'class': 'select-options'
    }).insertAfter($styledSelect);

    for (var i = 0; i < numberOfOptions; i++) {
      if ($this.children('option').eq(i).is(':selected')) {
        $styledSelect.text($this.children('option').eq(i).text());
      }
    }

    $styledSelect.on("click", function(e) {
			e.stopPropagation();
			$('div.select-styled.active').not(this).each(function(){
				$(this).removeClass('active').next('ul.select-options').hide();
			});
			var $selectOptions = $(this).closest('.select').find('.select-options').empty();
			for (var i = 0; i < numberOfOptions; i++) {
				var liProps = {
					text: $this.children('option').eq(i).text(),
					rel: $this.children('option').eq(i).val(),
					class: ($this.children('option').eq(i).attr('disabled') ? 'disabled' : ''),
				};
				$('<li />', liProps).appendTo($selectOptions);
			}			
			$selectOptions.find('li').on("click", function(e) {
				e.stopPropagation();
				if (!$(e.target).is('.disabled')) {
					$styledSelect.removeClass('active');
					$this.val($(this).attr('rel')).trigger("change");
					$selectOptions.hide();		
				}
			});	
      $(this).toggleClass('active').next('ul.select-options').toggle();
    })

		$this.on("change", function() {
		// sync select's value with front label
			var currentValue = $this.val();
			$styledSelect.removeClass('selected');
			for (var i = 0; i < numberOfOptions; i++) {
				if ($this.children('option').eq(i).attr('value') == currentValue) {
					$styledSelect.text($this.children('option').eq(i).text());
					if ($this.children('option').eq(i).val()) {
						$styledSelect.addClass('selected');
					}
				}
			}	
		});

    $(document).on("click", function() {
      $styledSelect.removeClass('active');
      $list.hide();
    })
	});

	// bug fix: changing qty on small doesn't also change qty on medium up. since update 
	// cart button gets qty values from the last input
	$(document.body).on('change', '.woocommerce-cart-form tbody.hide-for-medium input.qty.text', function(e) {
		var $target = $(this);
		var inputValue = $target.val();
		$('.woocommerce-cart-form tbody.show-for-medium input.qty[name="'+$target.attr('name')+'"]').val(inputValue);
	});

	$(document.body).on('woocommerce_variation_has_changed, reset_data', function (e) {
		var noAttrsSelected = true;
		var $resetVariationsButton = $('.reset_variations');
		$('form.variations_form select').each(function() {
			if ($(this).val()) {
				noAttrsSelected = false;
			}
			if (noAttrsSelected) {
				$resetVariationsButton.hide();
			} else {
				$resetVariationsButton.show();
			}
		})
	});

	// on variation selection, autoselect image on gallery
	$(document.body).on('show_variation', function(e) {
		var variation_id = $('input.variation_id').val();
		if (variation_id != '') {
			$('.carousel-prod-nav .carousel-prod-cell.product-image').each(function() {
				var imageVariationId = $(this).data('variation-id');
				imageVariationId = imageVariationId.toString().split(',');
				if (imageVariationId.indexOf(variation_id) != -1) {
					$('.carousel-prod-main').flickity('select', parseInt($(this).data('index')));
					return false;
				}
			})
		}
	});
	
	// checkout page: trigger shipping calculation on zipcode change - accommodate limited-area delivery like christmas tree, spring package, etc
	if ($('body.woocommerce-checkout').length > 0) {
		$('input#billing_postcode').on('change', function() {
			$('select#billing_state').trigger('change');
		});
		$('input#shipping_postcode').on('change', function() {
			$('select#shipping_state').trigger('change');
		});
	}

})(jQuery);

jQuery(document).on('gform_confirmation_loaded', function(event, formId){
	// hide intro paragraph on submit success
	if (formId == 2) {
		jQuery('#more-qty-overlay').find('.intro p').hide();
	} else if (formId == 3) {
		jQuery('#shipping-quote').find('.intro p').hide();
	}
});

function addQuantityBoxes(a) {
	var b, c = !1;
	a || (a = ".qty"), b = jQuery("div.quantity:not(.buttons_added), td.quantity:not(.buttons_added), .shipping-quote-dummy .ginput_container_number").find(a), b.length && (jQuery.each(b, function(a, b) {
		"date" === jQuery(b).prop("type") || "hidden" === jQuery(b).prop("type") || jQuery(b).parent().parent().hasClass("tribe-block__tickets__item__quantity__number") || jQuery(b).parent().hasClass("buttons_added") || (jQuery(b).parent().addClass("buttons_added").prepend('<button type="button" class="minus"><span>&ndash;</span></button>'), jQuery(b).addClass("input-text").after('<button type="button" class="plus"><span>+</span></button>'), c = !0)
	}), c && (jQuery("input" + a + ":not(.product-quantity input" + a + ")").each(function() {
		var a = parseFloat(jQuery(this).attr("min"));
		a && 0 < a && parseFloat(jQuery(this).val()) < a && jQuery(this).val(a)
	}), jQuery(".plus, .minus").unbind("click"), jQuery(".plus, .minus").on("click", function() {
		var b = jQuery(this).parent().find(a),
			c = parseFloat(b.val()),
			d = parseFloat(b.attr("max")),
			e = parseFloat(b.attr("min")),
			f = b.attr("step");
		c && "" !== c && "NaN" !== c || (c = 0), "" !== d && "NaN" !== d || (d = ""), "" !== e && "NaN" !== e || (e = 0), "any" !== f && "" !== f && void 0 !== f && "NaN" !== parseFloat(f) || (f = 1), jQuery(this).is(".plus") ? d && (d == c || c > d) ? b.val(d) : b.val(c + parseFloat(f)) : e && (e == c || c < e) ? b.val(e) : 0 < c && b.val(c - parseFloat(f)), b.trigger("change")
	})))
}

function compositeAddQuantityBoxes() {
	addQuantityBoxes()
}
jQuery(window).on("load", function() {
	addQuantityBoxes()
}), jQuery(document).ajaxComplete(function() {
	addQuantityBoxes()
}), jQuery(document).ready(function() {
	jQuery(".yith-wacp-mini-cart-icon").on("click", function() {
		setTimeout(function() {
			addQuantityBoxes()
		}, 100)
	})
}), jQuery(".composite_data").length && jQuery(".composite_data").on("wc-composite-initializing", function(a, b) {
	b.actions.add_action("component_selection_details_animated", compositeAddQuantityBoxes, 10)
});